import { deleteMethod, get, post, put } from "../api";

export const postService = async (url: string, data: any) => {
  try {
    const response = await post(url, data);
    return response.data;
  } catch (error) {
    throw handleSessionExpired(error);
  }
};
export const getService = async (url: string) => {
  try {
    const response = await get(url);
    return response.data;
  } catch (error) {
    throw handleSessionExpired(error);
  }
};
export const putService = async (url: string, data: any) => {
  try {
    const response = await put(url, data);
    return response.data;
  } catch (error) {
    throw handleSessionExpired(error);
  }
};
export const deleteService = async (url: string) => {
  try {
    const response = await deleteMethod(url);
    return response.data;
  } catch (error) {
    throw handleSessionExpired(error);
  }
};
export const handleSessionExpired = (error: any) => {
  if (
    error.response &&
    error.response.data &&
    error.response.data.message === "Session Expired"
  ) {
    localStorage.clear();
    window.location.href = "/login";
    alert("Your session has expired. Please log in again."); // Or use a modal/dialog
    // Optionally, redirect to the login page here if needed
    // window.location.href = '/login';
  }
  return error; // Return the error to be rethrown
};
